(function() {
  'use strict';

  angular.module('ringbaPortal').directive('sortableElements', sortableElements);

  function sortableElements(
    Draggable,
    mediaQueryService
  ) {
    'ngInject';

    const directive = {
      restrict: 'A',
      scope: {
        onSortStop: '&'
      },
      link: link
    };
    return directive;

    function link(scope, element, attributes) {
      let sortable = null,

        // Duplicate mirror is generated when the user drags the element out of the sourceContainer
        // to give the feeling of having the draggable element bound by the container.
        // shopify/draggable library will release the option of having draggable element bound by the container
        duplicateMirror = null;
      const duplicateMirrorClass = 'draggable-duplicate-mirror',
        sortableOptions = {
          draggable: attributes.draggableSelector,
          handle: attributes.draggableHandle,
          appendTo: attributes.appendTo,
          plugins: [Draggable.Plugins.SwapAnimation],
          mirror: {
            constrainDimensions: true,
            xAxis: false
          }
        },
        eventHandlers = {
          'mirror:created': onMirrorCreated,
          'mirror:move': onMirrorMove,
          'mirror:destroy': onMirrorDestroy,
          'sortable:stop': onSortStop
        };

      // This is for the duplicate mirror positioning
      $(attributes.appendTo).css('position', 'relative');

      sortable = new Draggable.Sortable(element[0], sortableOptions);
 
      // Only remove the Scrollable plugin on laptops with touchscreen
      // Here we don't remove the scrollable plugin on Mobile devices and tablet sized screens 
      // https://github.com/Shopify/draggable/issues/244 -> Bug with the draggable library, remove the below code once the issue is resolved
      if ('ontouchstart' in window && (!mediaQueryService.evaluateMediaQuery('xs') && !mediaQueryService.evaluateMediaQuery('sm'))) {
        sortable.removePlugin(Draggable.Draggable.Plugins.Scrollable);
      }

      function onMirrorCreated(ev) {
        // Sets the max-height of the container element to avoid jumping of elements due to height change.
        // This is a limiting approach but have tried using CSS to avoid this and it didn't work because elements move around when they are sorted.
        // - Abhi
        ev.sourceContainer.style.maxHeight = ev.sourceContainer.clientHeight + 'px';
      }

      function onMirrorMove(ev) {
        const sourceContainerBounds = ev.sourceContainer.getBoundingClientRect(),
          mirrorBounds = ev.mirror.getBoundingClientRect(),
          sourceContainerPadding = parseFloat($(ev.sourceContainer).css('padding'));

        if (mirrorBounds.top < sourceContainerBounds.top + sourceContainerPadding || mirrorBounds.bottom > sourceContainerBounds.bottom - sourceContainerPadding) {
          if (!duplicateMirror) {
            _positionDuplicateMirror(
              ev.mirror,
              ev.sourceContainer,
              mirrorBounds.top < sourceContainerBounds.top + sourceContainerPadding,
              sourceContainerPadding
            );
            ev.mirror.style.visibility = 'hidden';
          }
        } else if (duplicateMirror) {
          _removeDuplicateMirror(ev.sourceContainer);
          ev.mirror.style.visibility = '';
        }
      }

      function onMirrorDestroy(ev) {
        _removeDuplicateMirror(ev.sourceContainer);
      }

      function onSortStop(ev) {
        ev.oldContainer.style.maxHeight = '';
        scope.onSortStop({ ev: ev });
      }

      function _positionDuplicateMirror(originalMirror, sourceContainer, toPositionOnTop, sourceContainerPadding) {
        sourceContainerPadding = sourceContainerPadding || 0;
        const positionAbsoluteFromEdge = sourceContainerPadding + 'px';

        duplicateMirror = originalMirror.cloneNode(true);
        duplicateMirror.style.transform = '';
        duplicateMirror.style.position = 'absolute';
        duplicateMirror.style.top = toPositionOnTop ? positionAbsoluteFromEdge : '';
        duplicateMirror.style.bottom = !toPositionOnTop ? positionAbsoluteFromEdge : '';
        duplicateMirror.style.left = positionAbsoluteFromEdge;
        duplicateMirror.classList.add(duplicateMirrorClass);

        sourceContainer.appendChild(duplicateMirror);
      }

      function _removeDuplicateMirror(sourceContainer) {
        if (duplicateMirror) {
          sourceContainer.removeChild(duplicateMirror);
          duplicateMirror = null;
        }
      }

      for (const eventName in eventHandlers) {
        sortable.on(eventName, eventHandlers[eventName]);
      }

      scope.$on('$destroy', function () {
        if (sortable) {
          sortable.destroy();
        }
      });
    }
  }

})();
